import { render } from "./HomeView.vue?vue&type=template&id=31a4bd2c&scoped=true"
import script from "./HomeView.vue?vue&type=script&lang=js"
export * from "./HomeView.vue?vue&type=script&lang=js"

import "./HomeView.vue?vue&type=style&index=0&id=31a4bd2c&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-31a4bd2c"

export default script